/** AT06 copy (one group per control; a ticket edits only its own file). */
export const at06PtBr = {
  title: 'Tratamento dos arrendamentos no livro',
  description:
    'Cada arrendamento no escopo contra o tratamento do livro: direito de uso e passivo, ou isenção de curto prazo ou baixo valor.',
  prerequisite:
    'Requer a comparação de cada contrato com o tratamento do livro e o cronograma do passivo.',
  reasons: {
    DRAFT_PAST_COMMENCEMENT: 'Contrato em rascunho já iniciado',
    EXEMPTION_RATIONALE_MISSING: 'Isenção sem justificativa',
    SHORT_TERM_EXEMPTION_INVALID: 'Isenção de curto prazo acima de 12 meses ou com opção de compra',
    LOW_VALUE_THRESHOLD_MISSING: 'Isenção de baixo valor sem limite avaliado',
    EXEMPT_LEASE_RECOGNIZED: 'Contrato isento com direito de uso ou passivo no livro',
    RECOGNIZED_LEASE_EXPENSED: 'Contrato reconhecido tratado como despesa neste livro',
    TAX_BOOK_RECOGNIZES_LEASE: 'Livro fiscal com direito de uso ou passivo de arrendamento',
    ROU_ASSET_MISSING: 'Contrato reconhecido sem direito de uso no livro',
    ROU_COST_DIFFERS: 'Custo do direito de uso difere da mensuração',
    LIABILITY_SCHEDULE_MISSING: 'Contrato reconhecido sem cronograma do passivo',
    LIABILITY_SCHEDULE_DIFFERS: 'Cronograma do passivo difere da mensuração',
    LIABILITY_SCHEDULE_BROKEN: 'Cronograma do passivo remensurado não fecha',
    CURRENT_PORTION_STALE: 'Parcela circulante desatualizada no fim do período',
    RECOGNITION_NOT_POSTED: 'Reconhecimento sem lançamento contábil vigente',
    SETTLED_INSTALMENT_NOT_POSTED: 'Parcela liquidada sem lançamento contábil',
    DUE_INSTALMENT_NOT_SETTLED: 'Parcela vencida no período não liquidada',
    REMEASUREMENT_NOT_POSTED: 'Remensuração sem lançamento contábil',
    LEASE_LIABILITY_LEDGER_DIFFERS: 'Passivo do contrato no razão difere do cronograma',
    LEASE_LIABILITY_UNATTRIBUTED: 'Lançamento no passivo de arrendamento sem contrato de origem',
    ROU_RESIDUAL_UNSUPPORTED: 'Direito de uso com taxa residual, custo do livro não determinável',
  },
  hints: {
    DRAFT_PAST_COMMENCEMENT: 'Ative e reconheça o contrato, ou corrija a data de início.',
    EXEMPTION_RATIONALE_MISSING: 'Registre a justificativa da isenção no contrato.',
    SHORT_TERM_EXEMPTION_INVALID: 'Reclassifique o contrato como reconhecido.',
    LOW_VALUE_THRESHOLD_MISSING: 'Registre o limite de baixo valor avaliado no contrato.',
    EXEMPT_LEASE_RECOGNIZED: 'Reverta o reconhecimento ou reclassifique o contrato.',
    RECOGNIZED_LEASE_EXPENSED:
      'Cadastre um novo contrato que reconheça o direito de uso neste livro. O tratamento de um contrato ativo não pode ser alterado aqui; fale com o suporte para encerrar o atual.',
    TAX_BOOK_RECOGNIZES_LEASE: 'Mantenha o livro fiscal com as parcelas em despesa.',
    ROU_ASSET_MISSING: 'Refaça o reconhecimento do contrato neste livro.',
    ROU_COST_DIFFERS: 'Revise a base do direito de uso ou as remensurações do contrato.',
    LIABILITY_SCHEDULE_MISSING: 'Refaça o reconhecimento do contrato neste livro.',
    LIABILITY_SCHEDULE_DIFFERS: 'Revise o cronograma do passivo contra o contrato.',
    LIABILITY_SCHEDULE_BROKEN: 'Refaça a remensuração do contrato.',
    CURRENT_PORTION_STALE: 'Execute a reclassificação do passivo na data de fim do período.',
    RECOGNITION_NOT_POSTED: 'Lance novamente o reconhecimento do contrato.',
    SETTLED_INSTALMENT_NOT_POSTED: 'Lance a liquidação da parcela pela conta a pagar.',
    DUE_INSTALMENT_NOT_SETTLED: 'Liquide a parcela pela conta a pagar do locador.',
    REMEASUREMENT_NOT_POSTED: 'Lance a remensuração do contrato.',
    LEASE_LIABILITY_LEDGER_DIFFERS:
      'Confira os lançamentos do contrato no passivo e estorne o que não veio do reconhecimento, da remensuração ou da liquidação.',
    LEASE_LIABILITY_UNATTRIBUTED:
      'Estorne o lançamento manual e registre a mudança pelo contrato de arrendamento.',
    ROU_RESIDUAL_UNSUPPORTED:
      'Corrija a taxa residual do livro para zero neste contrato; um direito de uso não admite valor residual.',
  },
  observations: {
    AT06_SCOPE_UNRESOLVED: 'Moeda funcional ou período do livro não resolvidos',
    AT06_TREATMENT_MISSING: 'Contratos reconhecidos sem tratamento para este livro',
    AT06_TREATMENT_UNMEASURABLE:
      'Contratos que a mensuração nativa não representa (moeda, taxa ou norma); ficam parciais até haver um cronograma externo aprovado',
    AT06_NOT_MEASURABLE_AT_CUTOFF:
      'Contratos alterados depois do fim do período, fora da comparação',
    AT06_EXEMPT_EXPENSE_NOT_TRACED:
      'Contratos isentos cujos pagamentos em despesa não são rastreados aqui',
    AT06_CUTOVER_LEASES:
      'Contratos trazidos na implantação, sem lançamento de reconhecimento; o passivo de abertura é conferido contra o razão',
    AT06_LEASE_LIABILITY_UNMEASURABLE:
      'Contratos cujo passivo no razão não pode ser separado por contrato; ficam parciais',
    AT06_INTEREST_NOT_ACCRUED:
      'Contratos com pagamento não mensal cujos juros entre parcelas não estão no livro',
    AT06_LEASES_RETURNED: 'Contratos devolvidos até o fim do período, fora da mensuração',
    AT06_ENDED_CONTRACTS_NOT_JUDGED: 'Contratos encerrados ou vencidos, não avaliados',
    AT06_RESTRICTED_ACCOUNT_FINDINGS:
      'Pendências em contas com acesso restrito, contadas sem detalhes',
    AT06_CURRENCY_PRECISION_UNSUPPORTED:
      'Moeda funcional sem 2 casas decimais; a mensuração dos arrendamentos deste livro não foi feita',
  },
  observationHints: {
    AT06_SCOPE_UNRESOLVED: 'Configure a moeda funcional e o período deste livro.',
    AT06_TREATMENT_MISSING: 'Cadastre o tratamento do contrato para este livro.',
    AT06_TREATMENT_UNMEASURABLE: 'Confira estes contratos fora do sistema neste fechamento.',
    AT06_NOT_MEASURABLE_AT_CUTOFF: 'Avalie de novo depois do fechamento do período seguinte.',
    AT06_EXEMPT_EXPENSE_NOT_TRACED: 'Confira as contas a pagar destes contratos em despesa.',
    AT06_CUTOVER_LEASES: 'Confira o saldo de abertura do passivo contra a planilha da implantação.',
    AT06_LEASE_LIABILITY_UNMEASURABLE:
      'Mapeie as contas do passivo de arrendamento, informe o passivo de abertura dos contratos da implantação e liquide cada parcela por uma conta a pagar própria.',
    AT06_INTEREST_NOT_ACCRUED:
      'Os juros entre parcelas são reconhecidos quando a próxima parcela é liquidada; a provisão mensal pelo sistema é uma melhoria pendente. Se forem relevantes neste fechamento, provisione-os numa conta fora do passivo de arrendamento, com estorno no dia 1º do mês seguinte. Não lance juros nas contas do passivo de arrendamento: o controle apontaria um lançamento sem contrato e a despesa seria contada duas vezes.',
    AT06_LEASES_RETURNED: 'A baixa da devolução é conferida no controle de baixas.',
    AT06_ENDED_CONTRACTS_NOT_JUDGED: 'Confira a baixa destes contratos no controle de baixas.',
    AT06_RESTRICTED_ACCOUNT_FINDINGS:
      'Peça a quem tem acesso a essas contas para conferir o passivo de arrendamento.',
    AT06_CURRENCY_PRECISION_UNSUPPORTED:
      'A mensuração de arrendamentos só trabalha com moedas de 2 casas decimais. Os demais apontamentos deste livro foram avaliados; confira a mensuração destes contratos fora do sistema neste fechamento.',
  },
  precisionEvidence: {
    book: 'Livro {{code}}',
    currency: '{{currency}} com {{precision}} casas decimais; a mensuração usa {{supported}}',
    contracts: 'Contratos não medidos: {{list}}',
    contractsMore: '{{codes}} e mais {{count}}',
    ledgerSkipped:
      'O passivo no razão não foi conferido por contrato: a conferência depende da mensuração.',
    storedHeading:
      'Contratos não medidos ({{count}}), com os valores guardados no livro, não conferidos:',
    contract:
      '{{code}}: parcela {{payment}} {{frequency}} por {{term}} meses desde {{date}}; passivo no corte {{liability}}; custos diretos iniciais {{idc}}; provisão de restauração {{restoration}}; direito de uso {{rou}}',
    rouAsset: '{{amount}} ({{code}})',
    noSchedule: 'sem cronograma',
    noRou: 'não cadastrado',
    unlisted_one: 'E mais {{count}} contrato fora da lista.',
    unlisted_other: 'E mais {{count}} contratos fora da lista.',
    liabilityTotal: 'Passivo no corte, todos os contratos: {{amounts}}',
    rouTotal: 'Direito de uso, todos os contratos: {{amount}}',
    frequency: {
      MONTHLY: 'mensal',
      BIMONTHLY: 'bimestral',
      QUARTERLY: 'trimestral',
      SEMESTERLY: 'semestral',
      YEARLY: 'anual',
    },
  },
  account: 'Conta {{code}}',
  direction: {
    OVER: 'Livro acima do esperado: {{book}} contra {{expected}}',
    UNDER: 'Livro abaixo do esperado: {{book}} contra {{expected}}',
  },
  contract: 'Contrato {{code}}',
  openContract: 'Abrir contrato',
  listTruncated: 'Mostrando {{shown}} de {{total}} apontamentos.',
};

export const at06En: typeof at06PtBr = {
  title: 'Lease treatment in the book',
  description:
    'Each in-scope lease against the treatment in the book: right of use and liability, or a short-term or low-value exemption.',
  prerequisite: 'Needs each contract compared with the book treatment and the liability schedule.',
  reasons: {
    DRAFT_PAST_COMMENCEMENT: 'Draft contract already commenced',
    EXEMPTION_RATIONALE_MISSING: 'Exemption with no rationale',
    SHORT_TERM_EXEMPTION_INVALID: 'Short-term exemption over 12 months or with a purchase option',
    LOW_VALUE_THRESHOLD_MISSING: 'Low-value exemption with no assessed threshold',
    EXEMPT_LEASE_RECOGNIZED: 'Exempt contract with a right of use or liability in the book',
    RECOGNIZED_LEASE_EXPENSED: 'Recognized contract treated as expense in this book',
    TAX_BOOK_RECOGNIZES_LEASE: 'Tax book with a lease right of use or liability',
    ROU_ASSET_MISSING: 'Recognized contract with no right of use in the book',
    ROU_COST_DIFFERS: 'Right-of-use cost differs from the measurement',
    LIABILITY_SCHEDULE_MISSING: 'Recognized contract with no liability schedule',
    LIABILITY_SCHEDULE_DIFFERS: 'Liability schedule differs from the measurement',
    LIABILITY_SCHEDULE_BROKEN: 'Remeasured liability schedule does not add up',
    CURRENT_PORTION_STALE: 'Current portion out of date at the period end',
    RECOGNITION_NOT_POSTED: 'Recognition with no live journal',
    SETTLED_INSTALMENT_NOT_POSTED: 'Settled instalment with no journal',
    DUE_INSTALMENT_NOT_SETTLED: 'Instalment due in the period not settled',
    REMEASUREMENT_NOT_POSTED: 'Remeasurement with no journal',
    LEASE_LIABILITY_LEDGER_DIFFERS: 'Contract liability on the ledger differs from the schedule',
    LEASE_LIABILITY_UNATTRIBUTED: 'Entry on the lease liability with no source contract',
    ROU_RESIDUAL_UNSUPPORTED: 'Right of use with a residual rate, book cost cannot be determined',
  },
  hints: {
    DRAFT_PAST_COMMENCEMENT: 'Activate and recognize the contract, or correct its commencement.',
    EXEMPTION_RATIONALE_MISSING: 'Record the exemption rationale on the contract.',
    SHORT_TERM_EXEMPTION_INVALID: 'Reclassify the contract as recognized.',
    LOW_VALUE_THRESHOLD_MISSING: 'Record the assessed low-value threshold on the contract.',
    EXEMPT_LEASE_RECOGNIZED: 'Reverse the recognition or reclassify the contract.',
    RECOGNIZED_LEASE_EXPENSED:
      'Register a new contract that recognizes the right of use in this book. An active contract’s treatment cannot be changed here; contact support to end the current one.',
    TAX_BOOK_RECOGNIZES_LEASE: 'Keep the tax book with the payments in expense.',
    ROU_ASSET_MISSING: 'Recognize the contract again in this book.',
    ROU_COST_DIFFERS: 'Review the right-of-use base or the contract remeasurements.',
    LIABILITY_SCHEDULE_MISSING: 'Recognize the contract again in this book.',
    LIABILITY_SCHEDULE_DIFFERS: 'Review the liability schedule against the contract.',
    LIABILITY_SCHEDULE_BROKEN: 'Run the contract remeasurement again.',
    CURRENT_PORTION_STALE: 'Run the liability reclassification as of the period end.',
    RECOGNITION_NOT_POSTED: 'Post the contract recognition again.',
    SETTLED_INSTALMENT_NOT_POSTED: 'Post the instalment settlement through the bill.',
    DUE_INSTALMENT_NOT_SETTLED: 'Settle the instalment through the lessor bill.',
    REMEASUREMENT_NOT_POSTED: 'Post the contract remeasurement.',
    LEASE_LIABILITY_LEDGER_DIFFERS:
      'Check the contract’s entries on the liability and reverse any not from recognition, remeasurement or settlement.',
    LEASE_LIABILITY_UNATTRIBUTED:
      'Reverse the manual entry and record the change through the lease contract.',
    ROU_RESIDUAL_UNSUPPORTED:
      'Fix this book’s residual rate on the contract to zero; a right of use cannot carry a residual value.',
  },
  observations: {
    AT06_SCOPE_UNRESOLVED: 'Book functional currency or period not resolved',
    AT06_TREATMENT_MISSING: 'Recognized contracts with no treatment for this book',
    AT06_TREATMENT_UNMEASURABLE:
      'Contracts the native measurement cannot represent (currency, rate or framework); partial until an approved external schedule exists',
    AT06_NOT_MEASURABLE_AT_CUTOFF:
      'Contracts changed after the period end, left out of the comparison',
    AT06_EXEMPT_EXPENSE_NOT_TRACED: 'Exempt contracts whose expensed payments are not traced here',
    AT06_CUTOVER_LEASES:
      'Contracts carried in at go-live, with no recognition journal; their opening liability is checked against the ledger',
    AT06_LEASE_LIABILITY_UNMEASURABLE:
      'Contracts whose ledger liability cannot be told apart by contract; partial',
    AT06_INTEREST_NOT_ACCRUED:
      'Contracts paid less than monthly whose interest between instalments is not in the book',
    AT06_LEASES_RETURNED: 'Contracts returned by the period end, left out of the measurement',
    AT06_ENDED_CONTRACTS_NOT_JUDGED: 'Terminated or expired contracts, not judged',
    AT06_RESTRICTED_ACCOUNT_FINDINGS:
      'Open items on restricted-access accounts, counted without details',
    AT06_CURRENCY_PRECISION_UNSUPPORTED:
      'Functional currency without 2 decimal places; this book’s leases were not measured',
  },
  observationHints: {
    AT06_SCOPE_UNRESOLVED: 'Set up the functional currency and the period of this book.',
    AT06_TREATMENT_MISSING: 'Register the contract treatment for this book.',
    AT06_TREATMENT_UNMEASURABLE: 'Check these contracts outside the system for this close.',
    AT06_NOT_MEASURABLE_AT_CUTOFF: 'Evaluate again after the next period closes.',
    AT06_EXEMPT_EXPENSE_NOT_TRACED: 'Check the bills of these expensed contracts.',
    AT06_CUTOVER_LEASES: 'Check the opening liability against the go-live workbook.',
    AT06_LEASE_LIABILITY_UNMEASURABLE:
      'Map the lease-liability accounts, enter the opening liability of each go-live contract, and settle each instalment through its own bill.',
    AT06_INTEREST_NOT_ACCRUED:
      'Interest between instalments is recognised when the next instalment settles; monthly accrual by the system is a pending improvement. If it is material at this close, accrue it on an account outside the lease liability, reversed on the 1st of the next month. Do not post interest to the lease-liability accounts: the control would flag an entry with no contract and the expense would be counted twice.',
    AT06_LEASES_RETURNED: 'The return’s derecognition is checked by the disposals control.',
    AT06_ENDED_CONTRACTS_NOT_JUDGED:
      'Check these contracts’ derecognition in the disposals control.',
    AT06_RESTRICTED_ACCOUNT_FINDINGS:
      'Ask someone with access to these accounts to check the lease liability.',
    AT06_CURRENCY_PRECISION_UNSUPPORTED:
      'Lease measurement only works with 2-decimal currencies. The book’s other findings were evaluated; check these contracts’ measurement outside the system for this close.',
  },
  precisionEvidence: {
    book: 'Book {{code}}',
    currency: '{{currency}} with {{precision}} decimal places; the measurement uses {{supported}}',
    contracts: 'Contracts not measured: {{list}}',
    contractsMore: '{{codes}} and {{count}} more',
    ledgerSkipped:
      'The ledger liability was not checked by contract: that check depends on the measurement.',
    storedHeading:
      'Contracts not measured ({{count}}), with the amounts the book stores, not verified:',
    contract:
      '{{code}}: {{frequency}} instalment {{payment}} for {{term}} months from {{date}}; liability at the cutoff {{liability}}; initial direct costs {{idc}}; restoration provision {{restoration}}; right of use {{rou}}',
    rouAsset: '{{amount}} ({{code}})',
    noSchedule: 'no schedule',
    noRou: 'not recorded',
    unlisted_one: 'And {{count}} more contract not listed.',
    unlisted_other: 'And {{count}} more contracts not listed.',
    liabilityTotal: 'Liability at the cutoff, all contracts: {{amounts}}',
    rouTotal: 'Right of use, all contracts: {{amount}}',
    frequency: {
      MONTHLY: 'monthly',
      BIMONTHLY: 'bimonthly',
      QUARTERLY: 'quarterly',
      SEMESTERLY: 'semi-annual',
      YEARLY: 'annual',
    },
  },
  account: 'Account {{code}}',
  direction: {
    OVER: 'Book above expected: {{book}} against {{expected}}',
    UNDER: 'Book below expected: {{book}} against {{expected}}',
  },
  contract: 'Contract {{code}}',
  openContract: 'Open contract',
  listTruncated: 'Showing {{shown}} of {{total}} findings.',
};
